const o = "styles-module__sectionedFormOverview___14suZ", e = "styles-module__overviewFormTitle___qsQri", t = "styles-module__overviewQuestions___UMBTF", s = "styles-module__section___h6oCg", _ = "styles-module__sectionTitle___0k5Wy", i = "styles-module__uploadButton___IJCXR", n = "styles-module__submitButtonContainer___tz78o", r = "styles-module__overviewFormError___JuJIE", u = "styles-module__submitButton___krRBd", l = {
  sectionedFormOverview: o,
  overviewFormTitle: e,
  overviewQuestions: t,
  section: s,
  sectionTitle: _,
  uploadButton: i,
  submitButtonContainer: n,
  overviewFormError: r,
  submitButton: u
};
export {
  l as default,
  r as overviewFormError,
  e as overviewFormTitle,
  t as overviewQuestions,
  s as section,
  _ as sectionTitle,
  o as sectionedFormOverview,
  u as submitButton,
  n as submitButtonContainer,
  i as uploadButton
};
